import { useCallback } from 'react';
import useSWR from 'swr';
import { useClient } from '../../../../hooks/useClient';
import { useNavigateScroll } from '../../../../hooks/useNavigateScroll';
import { ExternalUser } from '../../../../types/externalUser';
import { ProfileOrganization } from '../types';

export const useProfileClient = ({
  organization,
  externalUserId,
}: {
  organization: ProfileOrganization;
  externalUserId: string | undefined;
}) => {
  const { get } = useClient();
  const navigate = useNavigateScroll();

  const externalUserFetcher = useCallback(
    (url: string) => {
      return get<ExternalUser>(url, {
        handlers: {
          [404]: () => {
            navigate(`/not-found`);
          },
        },
      });
    },
    [get, navigate],
  );
  const {
    data: user,
    mutate: mutateUser,
    isLoading: userLoading,
  } = useSWR(
    organization && externalUserId ? `/organizations/${organization.id}/external-users/${externalUserId}` : null,
    externalUserFetcher,
  );

  return { user, mutateUser, userLoading };
};
